export default __webpack_public_path__ + "static/media/question-mark.55be5296.svg";